import { render, staticRenderFns } from "./TableDash.vue?vue&type=template&id=89919e8c&scoped=true"
import script from "./TableDash.vue?vue&type=script&setup=true&lang=js"
export * from "./TableDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableDash.vue?vue&type=style&index=0&id=89919e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89919e8c",
  null
  
)

export default component.exports